export function capitalise(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

/**
 * Capitalises the first letter of every word in the given string.
 * @example
 * const result = toStartCase("HELLO world"); // => "Hello World"
 */
export function toStartCase(s: string) {
  return s.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
}
